import { Button } from "@/components/button";
import Modal from "@/components/custom-modal";
import { useSelectedPathStore } from "@/store/selectedPathStore";
import { useConfirmId } from "@/store/confirmStore";

interface ConfirmAreaProps {
  open: boolean;
  onClose: () => void;
  pathData: Array<{ name: string; area_id?: string; step?: number }>;
  onConfirm: () => void;
  agencyAreaAdd?: boolean;
}

const ConfirmArea = ({
  open,
  onClose,
  agencyAreaAdd = false,
  pathData,
  onConfirm,
}: Readonly<ConfirmAreaProps>) => {
  const { setConfirmId } = useConfirmId.getState();

  const { setSelectedPath } = useSelectedPathStore.getState();

  const selectedAreaPath = pathData.map((item) => item.name).join("، ");

  const handleCreateNewLevel = () => {
    setConfirmId(true);

    const updatedPathData = [...pathData];
    const lastIndex = updatedPathData.length - 1;
    const lastStep = Math.max(
      ...updatedPathData.map((item) => item.step ?? 0),
      0
    );

    updatedPathData[lastIndex] = {
      ...updatedPathData[lastIndex],
      step: lastStep + 1,
    };

    setSelectedPath([...updatedPathData]);

    const lastObjectId = pathData.at(-1)?.area_id;
    localStorage.setItem("coverage_area_id", lastObjectId || "");
    onConfirm();
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={
        agencyAreaAdd
          ? "تایید افزودن منطقه تحت پوشش"
          : "تایید انتخاب منطقه تحت پوشش"
      }
      className="w-[90%] max-w-140"
      animate={false}
    >
      <p className="text-base text-gray-600 leading-relaxed mb-6">
        شما منطقه تحت پوشش «{selectedAreaPath}» را انتخاب کرده‌اید، آیا ادامه
        می‌دهید؟
      </p>

      <div className="flex items-center justify-end gap-3">
        <Button
          text="انصراف"
          onClick={onClose}
          className="px-5 py-2.5 text-sm font-medium text-indigo-700 bg-white border border-indigo-600 hover:bg-indigo-50 transition-colors"
        />

        <Button
          text="تایید و افزودن"
          onClick={handleCreateNewLevel}
          iconName="lucide:check"
          className="px-6 py-2.5 text-sm font-medium text-white bg-indigo-600 border border-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 transition-colors"
        />
      </div>
    </Modal>
  );
};

export default ConfirmArea;
